import React from "react";
import PropTypes from "prop-types";

import { Container } from "./styles";
import { Tag } from "../../Tag";

function TagsDeCategorias(props) {
  return (
    <Container>
      {props.categorias?.map((categoria) => (
        <Tag text={categoria} />
      ))}
    </Container>
  );
}

TagsDeCategorias.propTypes = {
  categorias: PropTypes.array,
};

export default TagsDeCategorias;
